import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

// We can inject some CSS into the DOM.

const styles = theme => ({
  root: {
    borderRadius: '4px',
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    textTransform: 'unset',
    fontWeight: 'unset',
    '&:focus': { outline: 'none' },
  },
})

function ClassNames(props) {
  const { className, ...rest } = props
  return (
    <Button className={`${props.classes.root} ${className}`} style={{ ...props.style }} {...rest}>
      {props.children ? props.children : 'class names'}
    </Button>
  )
}

export default withStyles(styles)(ClassNames)
